import { useAct } from 'FlowBuilder/store'
import AsyncSelect from 'Shared/components/AsyncSelect'
import EditDecisionMakerSet from 'FlowBuilder/components/Modal/EditDecisionMakerSet'

export default function DecisionMakersForm({ actionId }) {
  const act = useAct()
  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const config = action.config || { decisionMakerSetId: '', emailSenderId: '', customDecisionMakers: false }
  const customDecisionMakers = config.customDecisionMakers || false

  function update(data) {
    act.actions.upsert(actionId, { config: { ...config, ...data } })
  }

  function openFilterDecisionMakerSetModal() {
    act.local.setModal({ kind: 'filterDecisionMakerSet', actionId })
  }

  const useNewDecisionMakers = () => {
    update({
      customDecisionMakers: true,
      decisionMakerSetId: config.customDecisionMakerSetId || null, // convenience to remember state
      inbuiltDecisionMakerSetId: config.decisionMakerSetId
    })
  }

  const useExistingDecisionMakers = () => {
    update({
      customDecisionMakers: false,
      decisionMakerSetId: config.inbuiltDecisionMakerSetId || null, // convenience to remember state
      customDecisionMakerSetId: config.decisionMakerSetId
    })
  }

  useEffect(() => {
    if (config.decisionMakerSetId) {
      act.decisionMakersSet.loadDecisionMakersSet(config.decisionMakerSetId, action.id)
    }
  }, [config.decisionMakerSetId])

  return <div>
    <div className='input-group to'>
      <h2 className='no-margin-top'>Who's the action to?</h2>
      <div className='margin-bottom'>
        <label>
          <input
          type="radio"
            name="useExistingDecisionMakers"
            checked={!customDecisionMakers}
            onChange={useExistingDecisionMakers}
          />
          Pick a list of recipients
        </label>
        {!customDecisionMakers && <div className='box danger-zone margin-top margin-bottom'>
          <label className="bold margin-bottom">Select a list of recipients</label>
          <AsyncSelect
            entity="decision_maker_set"
            value={config.decisionMakerSetId}
            onChange={value => update({ decisionMakerSetId: value })}
            loadStaticList
            groupBy={(opt) => opt.systemSlug ? 'Built-in sets' : 'Your sets'}
          />
          {config.decisionMakerSetId &&
            <button className='button primary margin-top' onClick={openFilterDecisionMakerSetModal}>Enable/disable recipients</button>
          }
        </div>}
        <label className="margin-top half">
          <input
            type="radio"
            name="useExistingDecisionMakers"
            checked={customDecisionMakers}
            onChange={useNewDecisionMakers}
          />
          Enter a list of recipients for this action
        </label>
      </div>
      { customDecisionMakers && <EditDecisionMakerSet actionId={actionId} /> }
    </div>
  </div>
}
